/**
 * Interface for the 'Folders' data
 */
export interface FoldersEntity {
  id: string | number; // Primary ID
  name: string;
}
